export const EVENT_DETAILS_QUERY_KEY = "eventDetails"
export const EVENT_DETAILS_PATH = "/events/"

export const ERROR_SERVER_SIDE_404_EVENT_DETAILS = "error_server_side_404_EVENT_DETAILS"

export const REGISTRATION_STATUS_ENDPOINT = "/jobteaser.event.v2alpha1/RegistrationService/GetRegistration"
export const REGISTRATION_STATUS_QUERY_KEY = "registrationStatus"

export const SUBSCRIBE_ENDPOINT = "/subscribe"
export const SWITCH_TO_SUBEVENT_PARAM = "?other_sub_event_id="
export const UNSUBSCRIBE_ENDPOINT = "/unsubscribe.json"

export const REMIND_ME_ENDPOINT = "/remind_me.json"

export const UNREMIND_ME_ENDPOINT = "/unremind_me.json"
